module.exports = __webpack_public_path__ + "a4fdc51c0f57c8a794270a49fa6cede0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = 455
// module chunks = 14